/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Invoice_Tags_Negative_ChargeInputs */

const en_admin_dashboard_invoice_tags_negative_charge = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Negative_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negative Charges`)
};

const de_admin_dashboard_invoice_tags_negative_charge = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Negative_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negative Gebühren`)
};

const es_admin_dashboard_invoice_tags_negative_charge = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Negative_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargos negativos`)
};

const fr_admin_dashboard_invoice_tags_negative_charge = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Negative_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frais négatifs`)
};

const it_admin_dashboard_invoice_tags_negative_charge = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Negative_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Addebiti negativi`)
};

const pt_br2_admin_dashboard_invoice_tags_negative_charge = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Negative_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cobranças negativas`)
};

const pl_admin_dashboard_invoice_tags_negative_charge = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Negative_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opłaty ujemne`)
};

const hu_admin_dashboard_invoice_tags_negative_charge = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Negative_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negatív díjak`)
};

const ro_admin_dashboard_invoice_tags_negative_charge = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Negative_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taxe Negative`)
};

/**
* | output |
* | --- |
* | "Negative Charges" |
*
* @param {Admin_Dashboard_Invoice_Tags_Negative_ChargeInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_invoice_tags_negative_charge = /** @type {((inputs?: Admin_Dashboard_Invoice_Tags_Negative_ChargeInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Invoice_Tags_Negative_ChargeInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_invoice_tags_negative_charge(inputs)
	if (locale === "de") return de_admin_dashboard_invoice_tags_negative_charge(inputs)
	if (locale === "es") return es_admin_dashboard_invoice_tags_negative_charge(inputs)
	if (locale === "fr") return fr_admin_dashboard_invoice_tags_negative_charge(inputs)
	if (locale === "it") return it_admin_dashboard_invoice_tags_negative_charge(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_invoice_tags_negative_charge(inputs)
	if (locale === "pl") return pl_admin_dashboard_invoice_tags_negative_charge(inputs)
	if (locale === "hu") return hu_admin_dashboard_invoice_tags_negative_charge(inputs)
	return ro_admin_dashboard_invoice_tags_negative_charge(inputs)
});
export { admin_dashboard_invoice_tags_negative_charge as "admin.dashboard.invoice_tags.negative_charge" }